module.exports = __webpack_public_path__ + "img/halfStar.183fad1c.svg";